/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import "./Effectivity.css";
import EffectivityForm from "./EffectivityForm";
import "../commons/Form.css";

const CreateEffectivity = () => {
  return (<EffectivityForm />);
};

export default CreateEffectivity;
